// Conservation Care Reducer
const conservationCareDefaultState = {
    conservation: ''
};

export default (state = conservationCareDefaultState, action) => {
    switch (action.type) {
        case 'SET_CONSERVATION_CARE':
            return {
                ...state,
                conservation: action.data.conservation
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/conservationCare.js